<template>
  <el-row>
    <el-col :span="24">
      <basic-container>
        <el-col :span="6">
<!--          值:{{form}}<br/>-->
          请选择：<avue-cascader v-model="form" :dic="dic"></avue-cascader>
          <el-button type="primary"
                     size="small"
                     @click="clickWxCode"
          >下载二维码</el-button>
        </el-col>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import { getWxCode,groupByDept2 } from "@/api/wx/wx";
export default {
    data () {
        return {
          form:[],
          dic:[],
        }
    },
    computed: {
    },
    watch: {
    },
    created () {
      groupByDept2().then(res=>{
        if(res.data.code === '0') {
          this.dic = res.data.data
          this.form = [res.data.data[0].value,res.data.data[0].children[0].value]
        }
      })

    },
    methods: {
      clickWxCode(){
        var deptName;
        var floorName;
        this.dic.filter(item=> {
          if(item.value === this.form[0]) {
            deptName = item.label
          }
          item.children.filter(child => {
            if(child.value === this.form[1]) {
              floorName = child.label
            }
          })
        })
        var url = "https://www.taclmy.com/rentbed/wx/getWxaCode?deptCode="+this.form[0]+"&floorCode="+this.form[1]+"&deptName="+deptName+"&floorName="+floorName;
        this.downFile(url);
        // getWxCode(this.form[0],this.form[1]).then(res=>{
        //   debugger
        //   const aLink = document.createElement('a')
        //   var blob = new Blob([res.data.data], { type: res.data.data.type })
        //   // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        //   var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        //   var contentDisposition = decodeURI(res.headers['content-disposition'])
        //   var result = patt.exec(contentDisposition)
        //   var fileName = result[1]
        //   fileName = fileName.replace(/\"/g, '')
        //   aLink.href = URL.createObjectURL(blob)
        //   aLink.setAttribute('download', fileName) // 设置下载文件名称
        //   document.body.appendChild(aLink)
        //   aLink.click()
        //   document.body.removeChild(aLink);
        // })
      }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/wx/wxCode.vue